<script>
  import Clipboard from 'clipboard';
  import hljs from 'highlight.js/lib/highlight';
  import xml from 'highlight.js/lib/languages/xml';
  import javascript from 'highlight.js/lib/languages/javascript';
  import {fade} from 'svelte/transition';

  hljs.registerLanguage('xml', xml);
  hljs.registerLanguage('javascript', javascript);
  hljs.initHighlightingOnLoad();

  export let id, snippet;

  // Copy to clipboard
  new Clipboard('.clipboard');

  let copied = false;

  const copyCode = () => {
    copied = true;

    setTimeout(() => {
      copied = false;
    }, 2000);
  };
</script>

<style>
  .clipboard:focus {
    outline-color: #00abcc;
    outline-style: solid;
    outline-width: 3px;
    outline-offset: 0.125em;
  }
</style>

<template>
  <div class="accordion mt-6 m-auto text-left">
    <div class="accordion-item w-full overflow-hidden">
      <input class="absolute opacity-0" id="{id}-snippet" type="checkbox" name="{id}-snippet" />
      <label class="block p-4 w-full bg-transparent cursor-pointer" for="{id}-snippet">
        <div class="flex items-center flex-no-wrap">
          <div class="border-box flex-grow-0 w-auto mr-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
              <g fill="none" fill-rule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                  class="fill-current"
                  d="M13.307 5.058l.101.013a.75.75 0 01.589.883l-2.482 12.402a.75.75 0 11-1.47-.294l2.48-12.402a.75.75 0 01.883-.589zM5.37 7.687a.75.75 0 11.9 1.2l-4.161 3.12 4.161 3.12a.75.75 0 11-.9
                  1.2L.41 12.608c-.4-.3-.4-.9 0-1.2zm12.251.15a.75.75 0 011.05-.15l4.961 3.72c.4.3.4.9 0 1.2l-4.96 3.72a.75.75 0 01-.9-1.2l4.16-3.12-4.16-3.12a.75.75 0 01-.15-1.05z" />
              </g>
            </svg>
          </div>
          <div class="border-box flex-grow w-auto max-w-full">
            <div class="text-sm m-0">View code snippet</div>
          </div>
          <div class="border-box flex-grow-0 w-auto pl-5">
            <div class="flex">
              <button type="button" class="clipboard mx-4" data-clipboard-text={snippet} on:click|preventDefault={copyCode}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                  {#if copied}
                    <g fill="none" fill-rule="evenodd" transition:fade={{delay: 0, duration: 500}}>
                      <path d="M0 0h24v24H0z" />
                      <path
                        class="fill-current text-brand-base"
                        fill-rule="nonzero"
                        d="M12.025 23.892c6.558 0 11.875-5.317 11.875-11.876C23.9 5.457 18.583.14 12.025.14 5.465.14.149 5.457.149 12.016c0 6.559 5.317 11.876 11.876 11.876zm0-1.5c-5.73
                        0-10.376-4.646-10.376-10.376 0-5.73 4.645-10.376 10.376-10.376 5.73 0 10.375 4.645 10.375 10.376 0 5.73-4.645 10.376-10.375 10.376zm-1.227-5.357l7.477-8.91a.75.75 0
                        00-1.15-.965l-6.92 8.248-3.344-3.73a.75.75 0 00-1.117 1l3.92 4.376a.75.75 0 001.134-.019z" />
                    </g>
                  {:else}
                    <path
                      in:fade={{delay: 500, duration: 0}}
                      fill="#444"
                      fill-rule="nonzero"
                      d="M19.875 4.5a2.25 2.25 0 012.25 2.25v15a2.25 2.25 0 01-2.25 2.25h-12a2.25 2.25 0 01-2.25-2.25v-15a2.25 2.25 0 012.25-2.25h12zm0 1.5h-12a.75.75 0 00-.75.75v15c0
                      .414.336.75.75.75h12a.75.75 0 00.75-.75v-15a.75.75 0 00-.75-.75zm-3.5-6c1.138 0 2 1.035 2 2.25a.75.75 0 11-1.5 0l-.006-.117c-.04-.378-.273-.633-.494-.633h-12.5c-.243
                      0-.5.309-.5.75v15c0 .441.257.75.5.75a.75.75 0 110 1.5c-1.138 0-2-1.035-2-2.25v-15c0-1.215.862-2.25 2-2.25z" />
                  {/if}
                </svg>
              </button>
              <div class="dropdown">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                  <path d="M11.902 16.65L1.282 6.03a.75.75 0 00-1.06 1.06l11.15 11.15a.75.75 0 001.06 0l11.15-11.15a.75.75 0 00-1.06-1.06l-10.62 10.62z" class="fill-current" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </label>
      <div class="accordion-item-content mb-3 overflow-auto bg-darkest rounded">
        <pre class="inline-block pr-6 text-sm text-white">
          <code>{snippet}</code>
        </pre>
      </div>
    </div>
  </div>
</template>
